// Thème visuel de l'application : sélection entre les jeux de couleurs du jeu (config/themes/) selon le thème
// actif (config/appTheme.js). Les couleurs de l'interface en CSS suivent le même thème (src/styles/themes.css).
import { APP_THEME } from './appTheme.js';
import { halloweenGameTheme, halloweenSceneryPalettes } from './themes/halloween.js';
import { luminousGameTheme, luminousSceneryPalettes } from './themes/luminous2027.js';

const THEMES = {
  halloween: { game: halloweenGameTheme, scenery: halloweenSceneryPalettes },
  2027: { game: luminousGameTheme, scenery: luminousSceneryPalettes },
};

export { APP_THEME };
export const gameTheme = THEMES[APP_THEME].game;
export const sceneryPalettes = THEMES[APP_THEME].scenery;
